import { render, staticRenderFns } from "./cat_admin.vue?vue&type=template&id=604def0f&"
import script from "./cat_admin.vue?vue&type=script&lang=js&"
export * from "./cat_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports